import { UAParser } from "ua-parser-js";

export type UserAgentResult = UAParser.IResult & { isCrawler: boolean };

const extraCrawlerUserAgents: UAParser.RegexMap = [
    [/(facebookexternalhit)\/([\w.]+)/i],
    [
        UAParser.BROWSER.NAME,
        UAParser.BROWSER.VERSION,
        [UAParser.BROWSER.TYPE, "crawler"],
    ],
];
export const parseUserAgent = (userAgent: string): UserAgentResult => {
    const parser = new UAParser({ browser: extraCrawlerUserAgents });
    parser.setUA(userAgent);
    const result = parser.getResult();
    const isUaCrawler = parser.getBrowser().type === "crawler";
    const botUserAgents = [/datadog/i, /pingdom/i, /uptimerobot/i];
    const isMonitoringBot = botUserAgents.some((pattern) =>
        pattern.test(userAgent)
    );
    return {
        ...result,
        isCrawler: isUaCrawler || isMonitoringBot,
    };
};

export const isAndroidSmsPreview = (userAgent: string): boolean => {
    // `Google-PageRenderer Google (+https://developers.google.com/+/web/snippet/`

    return (
        userAgent.includes("Google-PageRenderer") &&
        userAgent.includes("https://developers.google.com/+/web/snippet/")
    );
};
